import gql from "graphql-tag";
import { partsStoreDetailsFields } from "../queries/getPartsStore";

export const CREATE_PARTS_STORE = gql`mutation createPartsStore($partsStoreInput: PartsStoreInput!) {
    createPartsStore(partsStoreInput: $partsStoreInput) {
        ${partsStoreDetailsFields}
    }
}`;
